import { HttpErrorResponse } from '@angular/common/http';
import { OauthAEMConfig } from '../models';
import {
  AddMfaBackup,
  Authenticate,
  CancelAuthentication,
  ChangeUserPasswordInfo,
  CheckNewPassword,
  ContinueAuthentication,
  DefaultDevice,
  FlyDeltaPoll,
  InitiateAccountRecovery,
  InitiateAuthentication,
  InitiatePasswordChange,
  InitiateSsoSession,
  InitiateUserRegistration,
  MethodSelectionPayload,
  SelectDevice,
  SubmitEmailOtp,
  SubmitEmailResponse,
  SubmitFlyDeltaMethod,
  SubmitNewPassword,
  SubmitSkymilesNumber,
  SubmitSmsMethod,
  SubmitSmsNumber,
  SubmitSmsOtp,
  SubmitUserRegistration,
  UserRegistrationInfo
} from '../models/multi-factor-authentication.interfaces';

export const mfaAuthConfig: OauthAEMConfig = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE: 'openid',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'existingusermfaregistration',
  MFA_CLIENT_ID_VALUE: 'existingusermfaregistration',
  ISSUER: [],
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  PERSISTENT_LOGIN_ENABLE: true,
  PERSISTENT_COOKIE_TIMER: 0.01875,
  ENABLE_PING_LOGOUT: true,
  IS_USER_REMEMBERED: 'IS_USER_REMEMBERED',
  ISSUER_PROD: 'https://signin-dev.delta.com',
  LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
  REMEMBERED_DEVICE_DETAILS: 'REMEMBERED_DEVICE_DETAILS',
  REMEMBERME_API_FLOW_ENABLE: true,
  SCOPE_VALUE_RM: 'openid',
  SHOULD_REMEMBER_USER: 'SHOULD_REMEMBER_USER',
  VERSION_PARAMETER: 'v',
  VERSION_PARAMETER_VALUE: '1',
  VERIFY_EMAIL_MFA: 'verifyemailmfa',
  VERIFY_EMAIL_MFA_VALUE: 'yes',
  RESUME: 'RESUME',
  PING_DOMAIN: 'https://signin-dev.delta.com',
  PING_FLOW_ENABLED: true,
  BFF_CODES_TO_IGNORE: "['22', '127', '30', '51']",
  NU_TRAVEL_URL: [
    'https://businessmanagement.delta.com/',
    'https://deltauat-web01.nutravel.com/'
  ],
  IS_EMAIL_ALLOWED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  BAU_URLS: [
    'delta.com/mytrips/',
    'delta.com/vacations/',
    'delta.com/contactus/',
    'delta.com/buygftxfer/',
    'delta.com/skyclub/',
    'delta.com/cartalacarte/',
    'delta.com/seat/'
  ],
  COOKIE_DOMAIN: ';domain=.delta.com; path=/',
  COOKIE_DOMAIN_VALUE: '.delta.com',
  LOGIN_URLS: [
    '/login/loginPage',
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  REDIRECTION_URLS: [
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  PHASE_ONE_URLS: [
    '',
    '/us/en/need-help/overview',
    '/us/en/need-help/support-skymiles',
    '/us/en/need-help/support-other-information'
  ],
  LOGIN_PICKER:
    '/content/www/en_US/global-login/loginmodalpage.html/skymiles/profilePickerPage/',
  LOGIN_PICKER_STANDALONE: '/skymiles/profilePickerPage',
  DELETE_STANDALONE_COOKIE: true,
  MAKE_PE_CALL: true,
  ENABLE_NEW_PROFILE_SELECTOR: true,
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  ENABLE_NEW_PERSISTENT_LOGIN: false,
  REGISTER_SW_URL: '/skymiles/login-sw.js?2=1',
  FTWR_LOGIN_MODAL_COOKIE_AGE: 30,
  LOGIN_STANDALONE_PAGE_URL:
    '/content/www/en_US/global-login/loginmodalpage.html/skymiles/login',
  AWS_ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  ORION_FLYOUT: true
};

export const mfaAuthConfigFlyDeltaPollTimer: OauthAEMConfig = {
  FLY_DELTA_POLLING_TIMER: 5000,
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE: 'openid',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'existingusermfaregistration',
  MFA_CLIENT_ID_VALUE: 'existingusermfaregistration',
  ISSUER: [],
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  PERSISTENT_LOGIN_ENABLE: true,
  PERSISTENT_COOKIE_TIMER: 0.01875,
  ENABLE_PING_LOGOUT: true,
  IS_USER_REMEMBERED: 'IS_USER_REMEMBERED',
  ISSUER_PROD: 'https://signin-dev.delta.com',
  LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
  REMEMBERED_DEVICE_DETAILS: 'REMEMBERED_DEVICE_DETAILS',
  REMEMBERME_API_FLOW_ENABLE: true,
  SCOPE_VALUE_RM: 'openid',
  SHOULD_REMEMBER_USER: 'SHOULD_REMEMBER_USER',
  VERSION_PARAMETER: 'v',
  VERSION_PARAMETER_VALUE: '1',
  VERIFY_EMAIL_MFA: 'verifyemailmfa',
  VERIFY_EMAIL_MFA_VALUE: 'yes',
  RESUME: 'RESUME',
  PING_DOMAIN: 'https://signin-dev.delta.com',
  PING_FLOW_ENABLED: true,
  BFF_CODES_TO_IGNORE: "['22', '127', '30', '51']",
  NU_TRAVEL_URL: [
    'https://businessmanagement.delta.com/',
    'https://deltauat-web01.nutravel.com/'
  ],
  IS_EMAIL_ALLOWED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  BAU_URLS: [
    'delta.com/mytrips/',
    'delta.com/vacations/',
    'delta.com/contactus/',
    'delta.com/buygftxfer/',
    'delta.com/skyclub/',
    'delta.com/cartalacarte/',
    'delta.com/seat/'
  ],
  COOKIE_DOMAIN: ';domain=.delta.com; path=/',
  COOKIE_DOMAIN_VALUE: '.delta.com',
  LOGIN_URLS: [
    '/login/loginPage',
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  REDIRECTION_URLS: [
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  PHASE_ONE_URLS: [
    '',
    '/us/en/need-help/overview',
    '/us/en/need-help/support-skymiles',
    '/us/en/need-help/support-other-information'
  ],
  LOGIN_PICKER:
    '/content/www/en_US/global-login/loginmodalpage.html/skymiles/profilePickerPage/',
  LOGIN_PICKER_STANDALONE: '/skymiles/profilePickerPage',
  DELETE_STANDALONE_COOKIE: true,
  MAKE_PE_CALL: true,
  ENABLE_NEW_PROFILE_SELECTOR: true,
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  ENABLE_NEW_PERSISTENT_LOGIN: false,
  REGISTER_SW_URL: '/skymiles/login-sw.js?2=1',
  FTWR_LOGIN_MODAL_COOKIE_AGE: 30,
  LOGIN_STANDALONE_PAGE_URL:
    '/content/www/en_US/global-login/loginmodalpage.html/skymiles/login',
  AWS_ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  ORION_FLYOUT: true
};

export const initiateSsoSessionWithoutVerifyEmailMfaResponse: InitiateSsoSession =
  {
    id: 'swGLkyY7oG',
    pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
    status: 'AUTHENTICATION_REQUIRED',
    user: {
      username: 'f93ba892-2d16-4114-80d5-d07fb5841738'
    },
    _links: {
      cancelAuthentication: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      authenticate: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      self: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      }
    }
  };

export const initiateSsoSessionWithVerifyEmailMfaResponse: InitiateSsoSession =
  {
    id: 'xOf9wop5fR',
    pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
    status: 'USERNAME_PASSWORD_REQUIRED',
    showRememberMyUsername: false,
    showThisIsMyDevice: false,
    thisIsMyDeviceSelected: false,
    showCaptcha: false,
    rememberMyUsernameSelected: false,
    _links: {
      initiateAccountRecovery: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/xOf9wop5fR'
      },
      initiatePasswordChange: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/xOf9wop5fR'
      },
      self: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/xOf9wop5fR'
      },
      checkUsernamePassword: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/xOf9wop5fR'
      },
      initiateRegistration: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/xOf9wop5fR'
      }
    }
  };

export const initiateAuthenticationSuccessResponse: InitiateAuthentication = {
  id: 'swGLkyY7oG',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'OTP_REQUIRED',
  devices: [
    {
      id: '97249b37-574a-4fda-94d6-5cfe397d7790',
      type: 'Email',
      target: 'TE****@GMAIL.COM',
      usable: true,
      nickname: 'Email 1',
      defaultDevice: true
    }
  ],
  user: {
    username: 'f93ba892-2d16-4114-80d5-d07fb5841738'
  },
  selectedDeviceRef: {
    id: '97249b37-574a-4fda-94d6-5cfe397d7790'
  },
  manualPairingPermitted: true,
  manualPairing: false,
  userSelectedDefault: true,
  changeDevicePermitted: true,
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    setDefaultDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    selectDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    setupMfa: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    checkOtp: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    removeDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    },
    cancelRemoveDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
    }
  }
};

export const initiateAuthenticationNoDevicesSuccessResponse: InitiateAuthentication =
  {
    id: 'swGLkyY7oG',
    pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
    status: 'OTP_REQUIRED',
    user: {
      username: 'f93ba892-2d16-4114-80d5-d07fb5841738'
    },
    selectedDeviceRef: {
      id: '97249b37-574a-4fda-94d6-5cfe397d7790'
    },
    manualPairingPermitted: true,
    manualPairing: false,
    userSelectedDefault: true,
    changeDevicePermitted: true,
    _links: {
      cancelAuthentication: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      setDefaultDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      selectDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      setupMfa: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      self: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      checkOtp: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      removeDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      cancelRemoveDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      }
    }
  };

export const initiateAuthenticationSuccessResponseNoStatus: InitiateAuthentication =
  {
    id: 'swGLkyY7oG',
    pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
    status: '',
    devices: [
      {
        id: '97249b37-574a-4fda-94d6-5cfe397d7790',
        type: 'Email',
        target: 'TE****@GMAIL.COM',
        usable: true,
        nickname: 'Email 1',
        defaultDevice: true
      }
    ],
    user: {
      username: 'f93ba892-2d16-4114-80d5-d07fb5841738'
    },
    selectedDeviceRef: {
      id: '97249b37-574a-4fda-94d6-5cfe397d7790'
    },
    manualPairingPermitted: true,
    manualPairing: false,
    userSelectedDefault: true,
    changeDevicePermitted: true,
    _links: {
      cancelAuthentication: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      setDefaultDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      selectDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      setupMfa: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      self: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      checkOtp: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      removeDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      },
      cancelRemoveDevice: {
        href: 'https://signin-dev.delta.com/pf-ws/authn/flows/swGLkyY7oG'
      }
    }
  };

export const initiateAuthenticationResetPasswordSuccessMock: Authenticate = {
  id: 'oMgRq35WAx',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'DEVICE_SELECTION_REQUIRED',
  devices: [
    {
      id: '1246c2ab-56cd-4b68-aefb-1659246eca65',
      type: 'Email',
      target: 'vi****@gmail.com',
      usable: true,
      nickname: 'Email 1',
      defaultDevice: true
    },
    {
      id: '7cce2811-712c-49cf-805d-37333148bfd3',
      type: 'SMS',
      target: '*******98',
      usable: true,
      defaultDevice: false
    }
  ],
  user: {
    username: 'bdae76fe-46fe-4e01-9d89-9bdfc96ca5c0'
  },
  manualPairingPermitted: false,
  manualPairing: false,
  newPairingAuthRequired: true,
  usePasswordAuthenticationEnabled: false,
  userSelectedDefault: true,
  changeDevicePermitted: true,
  manageDevicesAllowed: false,
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    setDefaultDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    selectDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    setupMfa: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    removeDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    cancelRemoveDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    usePasswordAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    }
  }
};

export const submitEmailOtpSuccessResponse: SubmitEmailOtp = {
  id: 'Rq3OUuSutw',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'MFA_COMPLETED',
  code: 'com.pingidentity.pingone.web_login_email',
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    continueAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    }
  }
};

export const cancelAuthenticationSuccessResponse: CancelAuthentication = {
  id: '802wlmumUA',
  pluginTypeId: 'CmqYYkZJLFOAcDW4Ob1wXw',
  status: 'COMPLETED',
  authorizeResponse: {
    code: '6zWF_wkxkbmvyN1eG3Wry4xKzp0y2BGBh5IAAAAC',
    state: '1234'
  },
  user: {
    id: '2323434329',
    username: '2323434329'
  },
  _links: {
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/802wlmumUA'
    }
  }
};

export const addBackupMfaSuccessResponse: AddMfaBackup = {
  id: 'Rq3OUuSutw',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'DEVICE_PAIRING_METHOD_REQUIRED',
  devicePairingMethods: [
    {
      deviceType: 'Email'
    },
    {
      deviceType: 'SMS'
    },
    {
      deviceType: 'MOBILE',
      applicationName: 'EAM Sample App',
      applicationId: 'd108d10b-ad1a-4c9e-be03-07cf507d918e'
    }
  ],
  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    cancelDevicePairing: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    selectDevicePairingMethod: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    }
  }
};

export const addBackupMfaSuccessResponseNoStatus: AddMfaBackup = {
  id: 'Rq3OUuSutw',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: '',
  devicePairingMethods: [
    {
      deviceType: 'Email'
    },
    {
      deviceType: 'SMS'
    },
    {
      deviceType: 'MOBILE',
      applicationName: 'EAM Sample App',
      applicationId: 'd108d10b-ad1a-4c9e-be03-07cf507d918e'
    }
  ],
  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    cancelDevicePairing: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    selectDevicePairingMethod: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    }
  }
};

export const submitSmsMethodSuccessResponseMocks: SubmitSmsMethod = {
  id: 'hhY5DW0AUp',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'SMS_PAIRING_TARGET_REQUIRED',
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/hhY5DW0AUp'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/hhY5DW0AUp'
    },
    cancelDevicePairing: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/hhY5DW0AUp'
    },
    submitSmsTarget: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/hhY5DW0AUp'
    }
  }
};

export const submitSmsPayloadMocks: MethodSelectionPayload = {
  devicePairingMethod: {
    deviceType: 'SMS'
  }
};

export const submitFlyDeltaPayloadMocks: MethodSelectionPayload = {
  devicePairingMethod: {
    deviceType: 'MOBILE',
    applicationName: 'Fly Delta SDK Test',
    applicationId: 'e9d1899e-2e20-4bd5-bf16-356a0d785e5d'
  }
};

export const submitFlyDeltaMethodSuccessResponseMocks: SubmitFlyDeltaMethod = {
  id: 'DXN52kWMi3',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'MOBILE_ACTIVATION_REQUIRED',
  applicationName: 'Mobile app for testing sample MFA iOS application',
  pairingKey: '01140000568807',
  requestContext: {
    clientId: 'ac_oic_client',
    pluginId: 'P1MFA',
    trackedHttpParams: {
      scope: ['openid'],
      response_type: ['code'],
      client_id: ['ac_oic_client']
    },
    applicationName: 'OIDC AC Client',
    extendedProperties: {
      Type: 'sun',
      appId: 'ac_oic_client'
    }
  },
  _links: {
    cancelAuthentication: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    self: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    poll: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    cancelDevicePairing: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    }
  }
};

export const continueAuthenticationSuccessResponse: ContinueAuthentication = {
  id: 'Rq3OUuSutw',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'AUTHENTICATION_REQUIRED',
  user: {
    username: 'b498d60c-fc1c-4530-a357-87e5ad04fa66'
  },
  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    authenticate: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rq3OUuSutw'
    }
  }
};

export const submitSMSNumberSuccessResponse: SubmitSmsNumber = {
  id: 'EiNs3lmv2y',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'SMS_ACTIVATION_REQUIRED',
  phone: '+15627689876',
  _links: {
    resendOtp: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/EiNs3lmv2y'
    },
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/EiNs3lmv2y'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/EiNs3lmv2y'
    },
    activateSmsDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/EiNs3lmv2y'
    },
    cancelDevicePairing: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/EiNs3lmv2y'
    }
  }
};

export const submitSMSNumberFailureResponse: SubmitSmsNumber = {
  code: 'INVALID_PHONE',
  message: 'One or more validation errors occurred.'
};

export const submitSMSActivationSuccessResponse: SubmitSmsOtp = {
  id: 'd7V4HLrRLi',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'COMPLETED',
  code: 'com.pingidentity.pingone.web_login_email',
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/d7V4HLrRLi'
    },
    continueAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/d7V4HLrRLi'
    }
  }
};

export const initiateUserRegistrationSuccessResponse: InitiateUserRegistration =
  {
    id: 'wLGilYT3mI',
    pluginTypeId: 'CmqYYkZJLFOAcDW4Ob1wXw',
    status: 'REGISTRATION_REQUIRED',
    showCaptcha: false,
    showThisIsMyDevice: false,
    fields: [
      {
        id: 'firstName',
        label: 'First Name',
        type: 'Text',
        defaultValue: '',
        required: true,
        readonly: false
      },
      {
        id: 'lastName',
        label: 'Last Name',
        type: 'Text',
        defaultValue: '',
        required: true,
        readonly: false
      },
      {
        id: 'userName',
        label: 'User Name',
        type: 'Text',
        defaultValue: '',
        required: false,
        readonly: false
      },
      {
        id: 'primarySkymilesNumber',
        label: 'SkyMiles Number',
        type: 'Text',
        defaultValue: '',
        required: true,
        readonly: false
      },
      {
        id: 'email',
        label: 'email',
        type: 'Email',
        required: true,
        readonly: false
      }
    ],
    _links: {
      cancel: {
        href: 'https://signin-si.delta.com/pf-ws/authn/flows/wLGilYT3mI'
      },
      registerUser: {
        href: 'https://signin-si.delta.com/pf-ws/authn/flows/wLGilYT3mI'
      },
      self: {
        href: 'https://signin-si.delta.com/pf-ws/authn/flows/wLGilYT3mI'
      }
    }
  };

export const submitUserRegistrationSuccessResponse: SubmitUserRegistration = {
  id: 'wLGilYT3mI',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'AUTHENTICATION_REQUIRED',
  user: {
    username: 'bf93634b-a5b6-46d6-9efb-09b00f7ce094'
  },
  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/wLGilYT3mI'
    },
    authenticate: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/wLGilYT3mI'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/wLGilYT3mI'
    }
  }
};

export const flyDeltaPollSuccessMocks: FlyDeltaPoll = {
  id: 'DXN52kWMi3',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'MOBILE_ACTIVATION_REQUIRED',
  applicationName: 'Mobile app for testing sample MFA iOS application',
  pairingKey: '01140000568807',
  requestContext: {
    clientId: 'ac_oic_client',
    pluginId: 'P1MFA',
    trackedHttpParams: {
      scope: ['openid'],
      response_type: ['code'],
      client_id: ['ac_oic_client']
    },
    applicationName: 'OIDC AC Client',
    extendedProperties: {
      Type: 'sun',
      appId: 'ac_oic_client'
    }
  },
  _links: {
    cancelAuthentication: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    self: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    poll: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    cancelDevicePairing: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    }
  }
};

export const flyDeltaPollCompletedMocks: FlyDeltaPoll = {
  id: 'DXN52kWMi3',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'COMPLETED',
  applicationName: 'Mobile app for testing sample MFA iOS application',
  pairingKey: '01140000568807',
  requestContext: {
    clientId: 'ac_oic_client',
    pluginId: 'P1MFA',
    trackedHttpParams: {
      scope: ['openid'],
      response_type: ['code'],
      client_id: ['ac_oic_client']
    },
    applicationName: 'OIDC AC Client',
    extendedProperties: {
      Type: 'sun',
      appId: 'ac_oic_client'
    }
  },
  _links: {
    cancelAuthentication: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    self: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    poll: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    cancelDevicePairing: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    }
  }
};

export const flyDeltaRejectedMocks: FlyDeltaPoll = {
  id: 'LwJsQBwvoL',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'PUSH_CONFIRMATION_REJECTED',

  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    setDefaultDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    selectDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    setupMfa: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    updateDeviceNickname: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    removeDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    },
    cancelRemoveDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/LwJsQBwvoL'
    }
  }
};

export const flyDeltaPollTimedOutMocks: FlyDeltaPoll = {
  id: '2nKIMh6uLN',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'PUSH_CONFIRMATION_TIMED_OUT',

  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    setDefaultDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    selectDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    setupMfa: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    checkOtp: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    updateDeviceNickname: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    removeDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    },
    cancelRemoveDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2nKIMh6uLN'
    }
  }
};

export const flyDeltaPollAuthenticationRequiredMocks: FlyDeltaPoll = {
  id: 'DXN52kWMi3',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'AUTHENTICATION_REQUIRED',
  applicationName: 'Mobile app for testing sample MFA iOS application',
  pairingKey: '01140000568807',
  requestContext: {
    clientId: 'ac_oic_client',
    pluginId: 'P1MFA',
    trackedHttpParams: {
      scope: ['openid'],
      response_type: ['code'],
      client_id: ['ac_oic_client']
    },
    applicationName: 'OIDC AC Client',
    extendedProperties: {
      Type: 'sun',
      appId: 'ac_oic_client'
    }
  },
  _links: {
    cancelAuthentication: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    self: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    poll: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    cancelDevicePairing: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    }
  }
};

export const flyDeltaPollFailureMocks: FlyDeltaPoll = {
  id: 'DXN52kWMi3',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'FAILURE',
  applicationName: 'Mobile app for testing sample MFA iOS application',
  pairingKey: '01140000568807',
  requestContext: {
    clientId: 'ac_oic_client',
    pluginId: 'P1MFA',
    trackedHttpParams: {
      scope: ['openid'],
      response_type: ['code'],
      client_id: ['ac_oic_client']
    },
    applicationName: 'OIDC AC Client',
    extendedProperties: {
      Type: 'sun',
      appId: 'ac_oic_client'
    }
  },
  _links: {
    cancelAuthentication: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    self: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    poll: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    cancelDevicePairing: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    }
  }
};

export const flyDeltaCancelPairingSuccessResponse: AddMfaBackup = {
  id: 'DXN52kWMi3',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'DEVICE_PAIRING_METHOD_REQUIRED',
  devicePairingMethods: [
    {
      deviceType: 'Email'
    },
    {
      deviceType: 'SMS'
    },
    {
      deviceType: 'MOBILE',
      applicationName: 'EAM Sample App',
      applicationId: 'd108d10b-ad1a-4c9e-be03-07cf507d918e'
    }
  ],
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/ywIOr6oHEg'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/ywIOr6oHEg'
    },
    cancelDevicePairing: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/ywIOr6oHEg'
    },
    selectDevicePairingMethod: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/ywIOr6oHEg'
    }
  }
};

export const selectDeviceSuccessResponse: SelectDevice = {
  id: 'Q1PWfYBwAy',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'OTP_REQUIRED',
  devices: [
    {
      id: '3894b784-a714-476e-a1f4-db940ffb897e',
      type: 'Email',
      target: 'ro****@delta.com',
      usable: true,
      nickname: 'Email 1',
      defaultDevice: true
    }
  ],
  user: {
    username: '7b00bc65-2ec0-4bde-8ab4-0ee9efbcec38'
  },
  selectedDeviceRef: {
    id: '3894b784-a714-476e-a1f4-db940ffb897e'
  },
  manualPairingPermitted: false,
  manualPairing: false,
  userSelectedDefault: true,
  changeDevicePermitted: true,
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    setDefaultDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    selectDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    setupMfa: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    checkOtp: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    removeDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    cancelRemoveDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    }
  }
};

export const selectDeviceWithoutIdResponse: SelectDevice = {
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'OTP_REQUIRED',
  devices: [
    {
      id: '3894b784-a714-476e-a1f4-db940ffb897e',
      type: 'Email',
      target: 'ro****@delta.com',
      usable: true,
      nickname: 'Email 1',
      defaultDevice: true
    }
  ],
  user: {
    username: '7b00bc65-2ec0-4bde-8ab4-0ee9efbcec38'
  },
  selectedDeviceRef: {
    id: '3894b784-a714-476e-a1f4-db940ffb897e'
  },
  manualPairingPermitted: false,
  manualPairing: false,
  userSelectedDefault: true,
  changeDevicePermitted: true,
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    setDefaultDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    selectDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    setupMfa: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    checkOtp: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    removeDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    },
    cancelRemoveDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/Q1PWfYBwAy'
    }
  }
};

export const submitNewPasswordSuccessResponse: SubmitNewPassword = {
  id: 'LRMjLycgEs',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'SUCCESSFUL_PASSWORD_RESET',
  _links: {
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/LRMjLycgEs'
    },
    continueAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/LRMjLycgEs'
    }
  }
};

export const submitNewPasswordValidationErrorMock: SubmitNewPassword = {
  code: 'VALIDATION_ERROR',
  message: 'One or more validation errors occurred.',
  userMessage: 'One or more validation errors occurred.',
  details: [
    {
      code: 'ACCOUNT_RECOVERY_ERROR',
      message: 'Password reset error was encountered.',
      userMessage:
        'The password supplied does not meet policy restrictions. Please try again.',
      satisfiedValidators: [],
      failedValidators: [{ userMessage: 'validation failed' }]
    }
  ]
};

export const submitNewPasswordValidationMock: SubmitNewPassword = {
  code: 'VALIDATION_ERROR',
  message: 'One or more validation errors occurred.',
  userMessage: 'One or more validation errors occurred.',
  error: {
    details: [
      {
        code: 'ACCOUNT_RECOVERY_ERROR',
        message: 'Password reset error was encountered.',
        userMessage:
          'The password supplied does not meet policy restrictions. Please try again.',
        satisfiedValidators: [],
        failedValidators: [{ userMessage: 'validation failed' }]
      }
    ]
  }
};

export const submitSMSOTPErrorResponse: SubmitSmsOtp = {
  error: {
    code: 'VALIDATION_ERROR',
    message: 'One or more validation errors occurred.',
    userMessage: 'One or more validation errors occurred.',
    details: [
      {
        code: 'INVALID_OTP',
        message: 'An invalid or expired passcode was provided.',
        userMessage: 'This passcode is invalid or has expired.'
      }
    ]
  }
};

export const resourceNotFoundErrorResponse: SubmitSmsOtp = {
  error: {
    code: 'RESOURCE_NOT_FOUND',
    message: 'The requested resource was not found.'
  }
};

export const invalidActionIdErrorResponse: SubmitSmsOtp = {
  error: {
    code: 'INVALID_ACTION_ID',
    message:
      'The provided action ID is not valid for the current state of the flow.'
  }
};

export const accessDeniedErrorResponse: InitiateAuthentication = {
  id: 'Owo9pGc1tR',
  pluginTypeId: 'hbyDqlCJPHHz6ccE31vP2A',
  status: 'FAILED',
  code: 'access_denied',
  message: 'eamil modified too recently',
  userMessage: 'email modified too recently',
  trackingId: 'tid:xKEAzUBc7EKh0RjXeKU2V17kaHI',
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Owo9pGc1tR'
    }
  }
};

export const serverErrorMockResponse: SubmitEmailOtp = {
  code: 'SERVER_ERROR',
  error: {
    id: 'hbHSO3HS1q',
    pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
    status: 'MFA_FAILED',
    code: 'SERVER_ERROR',
    message: 'Server error.',
    userMessage: 'Server error.',
    requestContext: {
      clientId: 'ac_oic_client',
      pluginId: 'P1MFA',
      trackedHttpParams: {
        scope: ['openid'],
        response_type: ['code'],
        client_id: ['ac_oic_client']
      },
      applicationName: 'OIDC AC Client',
      extendedProperties: {
        Type: '1',
        appId: 'ac_oic_client'
      }
    },
    _links: {
      cancelAuthentication: {
        href: 'https://sso.verifiedself.com/pf-ws/authn/flows/hbHSO3HS1q'
      },
      self: {
        href: 'https://sso.verifiedself.com/pf-ws/authn/flows/hbHSO3HS1q'
      }
    }
  }
};

export const mfaHttpErrorResponse: HttpErrorResponse = {
  error: {
    error: 'Internal server error'
  },
  status: 500,
  name: 'HttpErrorResponse',
  message:
    'Http failure response for https://signin-si.delta.com/pf-ws/authn/flows/akdGNeHvol: 500 OK',
  ok: false,
  statusText: 'OK',
  url: 'https://signin-si.delta.com/pf-ws/authn/flows/akdGNeHvol'
} as HttpErrorResponse;

export const mfaHttpSuccessErrorResponse: HttpErrorResponse = {
  error: {
    error: ''
  },
  status: 200,
  name: 'HttpErrorResponse',
  message:
    'Http failure response for https://signin-si.delta.com/pf-ws/authn/flows/akdGNeHvol: 200 OK',
  ok: false,
  statusText: 'OK',
  url: 'https://signin-si.delta.com/pf-ws/authn/flows/akdGNeHvol'
} as HttpErrorResponse;

export const userRegistrationInfo: UserRegistrationInfo = {
  firstName: 'DCP',
  lastName: 'Thor',
  email: 'dcp.thor@gmail.com',
  userName: 'dcpthor',
  primarySkymilesNumber: '555555555'
};

export const initiateSelfPasswordResetMocks: InitiateAccountRecovery = {
  id: 'gV99RBh1Ba',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'ACCOUNT_RECOVERY_USERNAME_REQUIRED',
  showCaptcha: false,
  _links: {
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/gV99RBh1Ba'
    },
    checkAccountRecoveryUsername: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/gV99RBh1Ba'
    },
    cancelAccountRecovery: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/gV99RBh1Ba'
    }
  }
};

export const continueAuthenticationAccountRecoverySuccessResponse: ContinueAuthentication =
  {
    id: 'UV4mnhwfo3',
    pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
    status: 'PASSWORD_RESET_REQUIRED',
    showCaptcha: false,
    _links: {
      self: {
        href: 'https://signin-si.delta.com/pf-ws/authn/flows/UV4mnhwfo3'
      },
      cancelAccountRecovery: {
        href: 'https://signin-si.delta.com/pf-ws/authn/flows/UV4mnhwfo3'
      },
      checkPasswordReset: {
        href: 'https://signin-si.delta.com/pf-ws/authn/flows/UV4mnhwfo3'
      }
    }
  };

export const submitSkymilesNumberMocks: SubmitSkymilesNumber = {
  id: 'piCXxLbzUT',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'AUTHENTICATION_REQUIRED',
  user: {
    username: '33fdd351-cd5e-4f07-930f-be18768b40b3'
  },
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/piCXxLbzUT'
    },
    authenticate: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/piCXxLbzUT'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/piCXxLbzUT'
    }
  }
};

export const submitSkymilesNumberFailureMock: SubmitSkymilesNumber = {
  id: 'oNigxSyylG',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'MFA_FAILED',
  code: 'SERVICE_UNAVAILABLE',
  message: 'Service unavailable.',
  userMessage: 'Service unavailable.',
  _links: {
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/oNigxSyylG'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/oNigxSyylG'
    }
  }
};

export const removeMFAMethodMock: Authenticate = {
  id: 'swGLkyY7oG',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'DEVICE_SELECTION_REQUIRED',
  devices: [
    {
      id: '1246c2ab-56cd-4b68-aefb-1659246eca65',
      type: 'Email',
      target: 'vi****@gmail.com',
      usable: true,
      nickname: 'Email 1',
      defaultDevice: true
    },
    {
      id: '7cce2811-712c-49cf-805d-37333148bfd3',
      type: 'SMS',
      target: '*******98',
      usable: true,
      defaultDevice: false
    }
  ],
  user: {
    username: 'bdae76fe-46fe-4e01-9d89-9bdfc96ca5c0'
  },
  manualPairingPermitted: false,
  manualPairing: false,
  newPairingAuthRequired: true,
  usePasswordAuthenticationEnabled: false,
  userSelectedDefault: true,
  changeDevicePermitted: true,
  manageDevicesAllowed: false,
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    setDefaultDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    selectDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    setupMfa: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    removeDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    cancelRemoveDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    usePasswordAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    }
  }
};

export const submitEmailResponse: SubmitEmailResponse = {
  id: 'swGLkyY7oG',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'EMAIL_ACTIVATION_REQUIRED',
  email: 'test@delta.com',
  _links: {
    resendOtp: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/excBkMh0pY'
    },
    cancelAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/excBkMh0pY'
    },
    activateEmailDevice: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/excBkMh0pY'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/excBkMh0pY'
    },
    cancelDevicePairing: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/excBkMh0pY'
    }
  }
};

export const initiatePasswordChangeResponse: InitiatePasswordChange = {
  id: '2E7EoWsEAZ',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'NEW_PASSWORD_REQUIRED',
  showCaptcha: false,
  existingPasswordRequired: true,
  _links: {
    checkNewPassword: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2E7EoWsEAZ'
    },
    cancelPasswordChange: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2E7EoWsEAZ'
    },
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/2E7EoWsEAZ'
    }
  }
};

export const checkNewPasswordPayloadMocks: ChangeUserPasswordInfo = {
  username: '8015694139',
  existingPassword: 'Delta666',
  newPassword: 'Delta999'
};

export const checkNewPasswordResponse: CheckNewPassword = {
  id: 'Rbkb9Q2OHB',
  pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
  status: 'SUCCESSFUL_PASSWORD_CHANGE',
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rbkb9Q2OHB'
    },
    continueAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/Rbkb9Q2OHB'
    }
  }
};

export const checkNewPasswordErrorResponse: CheckNewPassword = {
  code: 'VALIDATION_ERROR',
  message: 'One or more validation errors occurred.',
  userMessage: 'One or more validation errors occurred.',
  details: [
    {
      code: 'PASSWORD_CHANGE_ERROR',
      message: 'Password change error was encountered.',
      userMessage: 'Current and new passwords must be different.'
    }
  ]
};

export const defaultDeviceResponse: DefaultDevice = {
  id: 'd7V4HLrRLi',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'COMPLETED',
  code: 'com.pingidentity.pingone.web_login_email',
  _links: {
    self: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/d7V4HLrRLi'
    },
    continueAuthentication: {
      href: 'https://signin-si.delta.com/pf-ws/authn/flows/d7V4HLrRLi'
    }
  }
};

export const changePrimaryVerificationMock: Authenticate = {
  id: 'yRuiHcDaJi',
  pluginTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'DEVICE_SELECTION_REQUIRED',
  devices: [
    {
      id: '1246c2ab-56cd-4b68-aefb-1659246eca65',
      type: 'Email',
      target: 'vi****@gmail.com',
      usable: true,
      nickname: 'Email 1',
      defaultDevice: true
    },
    {
      id: '7cce2811-712c-49cf-805d-37333148bfd3',
      type: 'SMS',
      target: '*******98',
      usable: true,
      defaultDevice: false
    }
  ],
  user: {
    username: 'bdae76fe-46fe-4e01-9d89-9bdfc96ca5c0'
  },
  manualPairingPermitted: false,
  manualPairing: false,
  newPairingAuthRequired: true,
  usePasswordAuthenticationEnabled: false,
  userSelectedDefault: true,
  changeDevicePermitted: true,
  manageDevicesAllowed: false,
  _links: {
    cancelAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    setDefaultDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    selectDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    setupMfa: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    self: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    removeDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    cancelRemoveDevice: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    },
    usePasswordAuthentication: {
      href: 'https://signin-dev.delta.com/pf-ws/authn/flows/oMgRq35WAx'
    }
  }
};

export const flyDeltaPollWaitingMocks: FlyDeltaPoll = {
  id: 'DXN52kWMi3',
  plugTypeId: 'j_AGR1E__nc2USbRhZPMQQ',
  status: 'PUSH_CONFIRMATION_WAITING',
  applicationName: 'Mobile app for testing sample MFA iOS application',
  pairingKey: '01140000568807',
  requestContext: {
    clientId: 'ac_oic_client',
    pluginId: 'P1MFA',
    trackedHttpParams: {
      scope: ['openid'],
      response_type: ['code'],
      client_id: ['ac_oic_client']
    },
    applicationName: 'OIDC AC Client',
    extendedProperties: {
      Type: 'sun',
      appId: 'ac_oic_client'
    }
  },
  _links: {
    cancelAuthentication: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    self: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    poll: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    },
    cancelDevicePairing: {
      href: 'https://sso.verifiedself.com/pf-ws/authn/flows/DXN52kWMi3'
    }
  }
};
